import HttpClient from "@/common/boot/HttpClient"

const listarDesignacao = async ({ commit }, payload) => {
  commit('CARREGANDO', true)
  try {
    const response = await HttpClient.post(
      `ctrl-designacao/visualizar`,
      payload
    )
    commit('LISTAR_DADOS', response.data.data.data)
    commit('ATUALIZAR_PAGINACAO', response.data.data)
    return response
  } catch (error) {
    console.error('Erro ao listar designações:', error)
    commit('LISTAR_DADOS', [])
    commit('ATUALIZAR_PAGINACAO', null)
  } finally {
    commit('CARREGANDO', false)
  }
}

const salvarDesignacao = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true)
  try {
    const response = await HttpClient.post('/ctrl-designacao', payload)
    await dispatch('listarDesignacao', { page: 1, current_page: 1, per_page: 20 })
    return response
  } catch (error) {
    console.error('Erro ao salvar designação:', error)
    throw error
  } finally {
    commit('CARREGANDO', false)
  }
}

const atualizarDesignacao = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true)
  try {
    const response = await HttpClient.put(`/ctrl-designacao/${payload.id}`, payload)
    await dispatch('listarDesignacao', { page: 1, current_page: 1, per_page: 20 })
    return response
  } catch (error) {
    console.error('Erro ao atualizar designação:', error)
    throw error
  } finally {
    commit('CARREGANDO', false)
  }
}


const importarDesignacoes = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true)
  try {
    const response = await HttpClient.post('/ctrl-designacao/importar', payload.formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    await dispatch('listarDesignacao', { page: 1, current_page: 1, per_page: 20 })
    return response
  } catch (error) {
    console.error('Erro ao importar designações:', error)
    throw error
  } finally {
    commit('CARREGANDO', false)
  }
}

const pesquisarDesignacoes = async (_context, payload) => {
  try {
    const response = await HttpClient.post('ctrl-designacao/visualizar', payload)
    return response.data?.data?.data || []
  } catch (error) {
    console.error('Erro ao pesquisar designações:', error)
    return []
  }
}

export {
  listarDesignacao,
  salvarDesignacao,
  atualizarDesignacao,
  importarDesignacoes,
  pesquisarDesignacoes
}
